<template>
    <nav class="atm-header-mobile-nav fixed left-0 top-14 z-xl h-[calc(100dvh-3.5rem)] w-full max-w-full bg-white lg:hidden">
        <div class="max-h-[calc(100dvh-3.5rem)] overflow-auto px-6">
            <div class="flex flex-col pt-7">
                <slot></slot>
            </div>
        </div>
    </nav>
</template>
